import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';
import { updateProductAttributes } from '@/api/products';
import { getQuery } from '@/utils';
import { getAttributes } from '@/api/attributes';
import HelpText from '@/components/HelpText/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
    this.attributes = [];
    this.selectedAttributes = []; // remove this with formData
    this.isReadOnly = false;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  activated() {
    this.getAttributes();
    // set tree nodes
    if (this.formData.attribute && this.formData.attribute.length) {
      this.selectedAttributes = this.formData.attribute.map(attribute => attribute.id);
      this.$refs.tree.setCheckedKeys(this.selectedAttributes);
    }
  }
  emitFormData() {
    this.selectedAttributes = this.$refs.tree.getCheckedKeys();
    this.$emit('updated', this.formData);
  }
  async getAttributes() {
    try {
      this.attributes = await getAttributes(getQuery({
        enabled: true,
        id: 1,
        filter: {
          enabled: 'eq',
          id: 'gt'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async saveForm() {
    this.loading = true;
    try {
      const attributesToSave = {
        attribute: []
      };
      this.selectedAttributes.forEach(id => {
        attributesToSave.attribute.push({
          id: id
        });
      });
      await updateProductAttributes(this.formData.id, attributesToSave);
      this.$notify({
        title: 'Success',
        message: 'Attributes saved',
        type: 'success',
        duration: 2000
      });
      this.$emit('reload', {});
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
};
__decorate([Prop({
  default: {}
})], default_1.prototype, "formData", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'ProductAttributeTab',
  components: {
    HelpText
  }
})], default_1);
export default default_1;